module.exports = __webpack_public_path__ + "img/timeline_mainevent-17.9ea633a1.jpg";